import { headerOrgAdmin } from "src/services/api/headers";
import { fetchWithAuth } from "src/services/http";

export default class StorageService {
  apiUrl = process.env.VUE_APP_API_ORGADMIN;
  baseUrl = `${this.apiUrl}/storages`;

  async getStorageSummaryByType() {
    const url = `${this.baseUrl}/summary`;
    const headers = await headerOrgAdmin();

    const response = await fetchWithAuth(url, {
      headers,
      credentials: "include",
      method: "GET",
    });

    const res = await response.json();

    if (!response.ok || (!res.success && res.code !== 200)) {
      const errorMsg = res.message || res.error_code || 'An error occurred'
      throw new Error(errorMsg);
    }

    return res;
  }

  async getAllUsersStorageUsage(page = 1, limit = 10, search = "") {
    const params = new URLSearchParams({ page, limit, search });
    const url = `${this.baseUrl}/users?${params}`;
    const headers = await headerOrgAdmin();

    const response = await fetchWithAuth(url, {
      headers,
      credentials: "include",
      method: "GET",
    });

    const res = await response.json();

    if (!response.ok || (!res.success && res.code !== 200)) {
      const errorMsg = res.message || res.error_code || 'An error occurred'
      throw new Error(errorMsg);
    }

    return res;
  }


  async switchStorageToMonthly(id) {
    const url = `${this.baseUrl}/${id}/switch-monthly`;
    const headers = await headerOrgAdmin();

    const response = await fetchWithAuth(url, {
      headers,
      credentials: "include",
      method: "GET",
    });

    const res = await response.json();
    return res;
  }

}